export default __webpack_public_path__ + "static/media/logo.d757706f.svg";